<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- Read More Button JS -->
  
jQuery(document).ready(function ($) {
   // Use event delegation so it works even if the page reloads via Ajax/filters
   $(document).off('click', '.gc-show-more-toggle').on('click', '.gc-show-more-toggle', function (e) {
       e.preventDefault();
       
       // Find the main wrapper, then find the specific content inside it
       var wrapper = $(this).closest('.collection-description');
       var content = wrapper.find('.gc-show-more-content');
       
       // Toggle the text block
       content.slideToggle("300");
       
       // Toggle the active class on the button
       $(this).toggleClass('gc-show-more-toggle_active');
       
       // Update the button text
       if ($(this).hasClass('gc-show-more-toggle_active')) {
           $(this).html('Read Less');
       } else {
           $(this).html('Read More');
       }
   });
});
  
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->